export default "__VITE_ASSET__Dv62A_hC__"